import { ModuleRoutes } from '@kiplin/web-common/architecture-core';
import { loadLazyAppModuleGuard } from '@kiplin/web-common/dependency-injection';
import { EstablishmentRouteName } from '@client/feature/establishment/application/routes/establishment.route-name';
import type { Container } from 'inversify';
import type { RouteRecordRaw } from 'vue-router';
import { checkCurrentClientUserHasClient } from '@client/common/router/application/routes/check-current-client-user-has-client.route-guard';
import { checkClientHasSubscription } from '@client/common/router/application/routes/check-client-has-subscription.route-guard';

const EstablishmentAppModule = () => import('@client/feature/establishment/establishment.app-module');
const EstablishmentPage = () => import('@client/feature/establishment/application/page/EstablishmentPage.vue');

export class EstablishmentModuleRoutes extends ModuleRoutes<EstablishmentRouteName> {
  constructor(container: Container) {
    const routes: RouteRecordRaw[] = [
      {
        path: 'establishments/list',
        name: EstablishmentRouteName.List,
        component: EstablishmentPage,
        beforeEnter: [
          loadLazyAppModuleGuard(EstablishmentAppModule, container),
          () => checkCurrentClientUserHasClient(),
          () => checkClientHasSubscription(),
        ],
      },
    ];

    super(routes);
  }
}
